<template>
  <main-wrapper transparent-footer>
    <template #header>
      <be-header :back-to-route="'Home'" :is-back="!isBasket" />
    </template>
    <template #footer>
      <div class="text-center">
        <p>{{ $t('b2c_have_an_account') }} <be-link to="/login" variant="primary" class="fw-600">{{ $t('b2c_login') }}</be-link></p>
      </div>
    </template>

    <h1 class="be-h1">{{ $t('b2c_welcome_let_us_find') }}</h1>
    <be-basket-info v-if="isBasket" is-basket is-timer/>
    <div class="btn-group-vertical">
      <be-button
          :is-full="true"
          variant="primary"
          @click="$router.push({ path: '/create-account' });"
      >
        {{ $t('b2c_sign_up_with_email') }}
      </be-button>
      <span class="or-text">{{ $t('b2c_or') }}</span>
      <be-google-auth-button>{{ $t('b2c_continue_with_google') }}</be-google-auth-button>
      <be-apple-auth-button v-if="device && device.platform === 'ios'">{{ $t('b2c_continue_with_apple') }}</be-apple-auth-button>
    </div>
  </main-wrapper>
</template>

<script>
import BeLink from "../../components/common/BeLink";
import BeButton from "../../components/common/BeButton";
import MainWrapper from "@/components/common/MainWrapper";
import BeHeader from "@/components/BeHeader";
import BeGoogleAuthButton from "@/components/common/BeGoogleAuthButton";
import BeAppleAuthButton from "@/components/common/BeAppleAuthButton";
import BeBasketInfo from "@/components/common/BeBasketInfo";

export default {
  name: "SignUpView",
  components: {BeBasketInfo, BeAppleAuthButton, BeGoogleAuthButton, MainWrapper, BeLink, BeButton, BeHeader},
  computed: {
    isBasket() {
      return this.$store.getters.savedBasket.length > 0
    },
    device() {
      return this.$store.getters.device
    }
  }
}
</script>
